import { useMutation } from '@tanstack/react-query'
import { useCallback } from 'react'
import {
  DownloadByArquivoMutationMutation,
  DownloadByArquivoMutationMutationVariables
} from '../types/graphql'
import { request } from '../utils/request'
import { downloadByArquivoGql } from '../data/download-by-arquivo'
import { downloadByLink } from '../components/uploader-utils'

export const useDownloads = () => {
  const downloadByArquivoMutation = useMutation({
    mutationKey: ['downloadByArquivo'],
    mutationFn: async (variables: DownloadByArquivoMutationMutationVariables) =>
      await request<
        DownloadByArquivoMutationMutation,
        DownloadByArquivoMutationMutationVariables
      >(downloadByArquivoGql, { variables })
  })

  const handleDownload = useCallback(
    async ({
      idArquivo,
      registrarDownload
    }: {
      idArquivo: string
      registrarDownload: boolean
    }) => {
      try {
        const response = await downloadByArquivoMutation.mutateAsync({
          idArquivo,
          registrarDownload
        })
        const link = response?.downloadByArquivo
        if (link) {
          downloadByLink(link)
        }
      } catch (err) {
        console.error('Erro ao fazer o download:', err)
      }
    },
    [downloadByArquivoMutation]
  )

  return { handleDownload }
}
